function getSafe(accessor) {
    try {
      return accessor();
    }
    catch(err) {
      return null;
    }
}

export default getSafe;